import type { FrameData } from '@/core/annotations'
import type { BBox } from '@/modules/Editor/types'

import { calcPathBBox } from './calcPathBBox'

export const calcSkeletonBBox = (data: FrameData): BBox | undefined => {
  if (!data.skeleton) {
    return
  }

  return calcPathBBox(data.skeleton.nodes)
}
